module.exports = __webpack_public_path__ + "static/media/maxSuccessionLosses_50_60.16f1ec21.png";